<form class="container-fluid" [formGroup]="TransactionFormGroup">
  <div class="row row-padding">
    <div class="col">
      <label class="fs-28">Edit Invoice / Manual Transaction</label>
    </div>
  </div>
  <div class="row row-padding">
    <div class="col-4">
      <div class="row">
        <div class="col">
          <label
            >Ref. Number<span class="required-field-asterisk">*</span></label
          >
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input type="text" class="form-control" formControlName="refNumber" />
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col">
          <label
            >Transaction Type<span class="required-field-asterisk"
              >*</span
            ></label
          >
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="transType">
            @for (TransactionType of TransactionTypes; track TransactionType) {
              <option [ngValue]="TransactionType">
                {{ TransactionType }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col">
          <label
            >Transaction Method<span class="required-field-asterisk"
              >*</span
            ></label
          >
        </div>
      </div>
      <div class="row">
        <div class="col">
          <select class="form-select" formControlName="transMethod">
            @for (
              TransactionMethod of TransactionMethods;
              track TransactionMethod
            ) {
              <option [ngValue]="TransactionMethod">
                {{ TransactionMethod }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="row row-padding">
    <div class="col-4">
      <div class="row">
        <div class="col">
          <label>Paid Date<span class="required-field-asterisk">*</span></label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              placeholder="MM/DD/YYYY"
              [formControl]="
                TransactionFormGroup.controls['Invoice'].controls['paidDate']
              "
              navigation="select"
              ngbDatepicker
              container="body"
              #paidDatePicker="ngbDatepicker"
              appNgbDateInputMask
            />
            <button
              class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
              (click)="paidDatePicker.toggle()"
              type="button"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col">
          <label>Amount</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input type="text" class="form-control" formControlName="amount" />
        </div>
      </div>
    </div>
  </div>
  <div class="row row-padding">
    <div class="offset-6 col-3">
      <button class="btn btn-secondary" (click)="close()">Cancel</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</form>
